import React, { useEffect, useState } from "react";
import { notification, Button } from "antd";
import { useSelector } from "react-redux";

const NotificationPopup = () => {
  const { user } = useSelector((state) => state.user);
  const popupKey = "unseen-notification-popup";
  const localStorageKey = `notificationDismissed_${user?._id}`; // per user

  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(localStorageKey) === "true"
  );

  useEffect(() => {
    if (user?.unseenNotifications?.length && !dismissed) {
      const timer = setTimeout(() => {
        notification.open({
          key: popupKey,
          message: "🔔 You have unread notifications",
          description: (
            <>
              You currently have <b>{user.unseenNotifications.length}</b> unseen
              notification(s).
              <br />
              <Button
                size="small"
                type="text"
                style={{ marginTop: 10, color: "red" }}
                onClick={() => {
                  setDismissed(true);
                  localStorage.setItem(localStorageKey, "true"); // save flag
                  notification.destroy(popupKey);
                }}
              >
                Don’t show this again
              </Button>
            </>
          ),
          duration: 0,
          placement: "topRight",
        });
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [user, dismissed, localStorageKey]);

  return null;
};

export default NotificationPopup;
